import { render, staticRenderFns } from "./BatchHeader.vue?vue&type=template&id=26b7c2c5"
import script from "./BatchHeader.vue?vue&type=script&lang=js"
export * from "./BatchHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports